export default __webpack_public_path__ + "static/media/Kayla 9781408331415.9178dd3e.jpg";